import { firestore } from '../../utils/firebase'

export const RECEIVED_HOME = 'RECEIVED_HOME'

function receivedHome (home) {
  return {
    type: RECEIVED_HOME,
    home
  }
}

export function fetchHome (homeId) {
  return async dispatch => {
    const propertyForReviewDoc = await firestore
      .collection('properties_for_review')
      .doc(homeId)
      .get()

    if (propertyForReviewDoc.exists) {
      let data = propertyForReviewDoc.data()
      dispatch(receivedHome(data))

      return data
    } else {
      return false
    }
  }
}
